import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,App } from 'ionic-angular';
import {UpdatepersonalPage} from '../updatepersonal/updatepersonal'
import {UpdatecontactPage} from '../updatecontact/updatecontact'
import {UpdateaddressPage} from '../updateaddress/updateaddress'

/**
 * Generated class for the UpdateinfoloadingsrPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-updateinfoloadingsr',
  templateUrl: 'updateinfoloadingsr.html',
})
export class UpdateinfoloadingsrPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,private app:App) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad UpdateinfoloadingsrPage',this.navParams);
  }
  goToPageName(pageName){
    let nav = this.app.getRootNav();
    
  if(pageName=='updateinfolandingsr'){
    //console.log("updateinfolandingsr");
    nav.push(UpdatepersonalPage);
    // this.navCtrl.setRoot(UpdatepersonalPage)
  }else if(pageName=='documentstatement'){
    //console.log(pageName)
    nav.push(UpdatecontactPage,this.navParams)
  }else if(pageName=='partpayment'){
    //console.log(pageName)
    nav.push(UpdateaddressPage,this.navParams)
  }else{
    //console.log(pageName)
    nav.push(UpdateaddressPage,this.navParams)
  }
  
}

}



// WEBPACK FOOTER //
// ./src/pages/updateinfoloadingsr/updateinfoloadingsr.ts